import Hero from "../components/HomePage/Hero.jsx";
import IdentitySplit from "../components/HomePage/IdentitySplit.tsx";
import IndustriesChips from "../components/HomePage/IndustriesChips.tsx";
import ServicesSlider from "../components/HomePage/ServicesSlider.tsx";
import Contact from "../components/HomePage/Contact.tsx";
// import TeamMembers from "../components/HomePage/TeamMembers.tsx";

function Home() {
  return (
    <div>
      <section id="hero">
        <Hero />
      </section>

      <section id="identity">
        <IdentitySplit />
      </section>

      {/* <section id="teamMembers">
        <TeamMembers />
      </section> */}

      <section id="services">
        <ServicesSlider />
      </section>

      <section id="industries">
        <IndustriesChips />
      </section>

      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default Home;
